import { useTranslation } from 'react-i18next'
import { useImageModels } from '../../hooks/useImageModels'
import { getImageModelLabel } from '../../constants/modelAliases'

export function PreferredImageModelSection({
  value, disabled, onChange,
}: {
  value: string
  disabled: boolean
  onChange: (model: string) => Promise<void>
}) {
  const { t } = useTranslation('canvas')
  const { native, byom, isLoading, error } = useImageModels()
  const available = native.includes(value) || byom.some((model) => model.id === value && model.enabled)
  return (
    <div className="space-y-2">
      <label htmlFor="preferred-image-model" className="block text-sm font-medium text-foreground">
        {t('projectConfigGear.preferredImageModel')}
      </label>
      <p className="text-xs text-muted-foreground">{t('projectConfigGear.preferredImageModelDescription')}</p>
      <select
        id="preferred-image-model"
        data-testid="project-config-preferred-image-model"
        value={value}
        disabled={disabled || isLoading}
        onChange={(event) => void onChange(event.target.value)}
        className="h-9 w-full rounded-lg border border-input-border bg-input-bg px-3 text-sm text-foreground hover:border-input-border-hover hover:bg-surface-2 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 disabled:opacity-50"
      >
        <option value="auto">{t('projectConfigGear.preferredImageModelAuto')}</option>
        {value !== 'auto' && !available && <option value={value} disabled>{t('projectConfigGear.preferredVideoModelsUnavailable', { name: value })}</option>}
        {native.map((model) => <option key={model} value={model}>{getImageModelLabel(model)}</option>)}
        {byom.filter((model) => model.enabled).map((model) => <option key={model.id} value={model.id}>{model.key_name}</option>)}
      </select>
      {error && <p role="alert" className="text-xs text-destructive">{error}</p>}
    </div>
  )
}
